import React from "react";

const WhistleIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 40 40"
    width="1em"
    height="1em"
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g transform="translate(0, 8.140834363188091) scale(1.0563766017402303)">
      <polygon points="16.56 0 22.14 3.23 19.43 4.85 13.91 1.59 16.56 0" />
      <polygon points=".02 8.85 8.42 13.91 8.42 18.94 0 13.86 .02 8.85" />
      <path d="M10,13.32L29.63,1.97c2.72-1.54,6.15-1.59,7.6,1.61,1.93,4.29-.92,11.05-3.78,14.4-2.13,2.5-6.6,5.87-9.96,3.86-2.6-1.55-2.63-5.44-2.11-8.07l-11.38,6.51v-6.95Z" />
    </g>
  </svg>
);

export default WhistleIcon;
